import React from 'react';

import "./menu.css"
import {getCompanyRelation} from "./operations/fetch";
import {Link} from "@reach/router";

export default class Menu extends React.Component {

    constructor(props) {
        super(props);

        let admin = false;

        if (this.props.user.cognitoUser === "e836cfb9-7ef4-4d60-be07-fa679b5d4dcc" ||
            this.props.user.cognitoUser === "e0281a2a-f15c-4d37-8519-06d8f8194af9" ||
            this.props.user.cognitoUser === "bd447d1f-67a0-40bf-9bb0-ecb6acc244eb"
        ) {
            admin = true;
        }

        this.state = {
            showProfileMenu: false,
            showMeasurement: false,
            alternative: "Measurements",
            admin: admin,
            company: [],
            history: [],
        };
        this.fetchInitialData()
    }

    async fetchInitialData() {
        this.setState({company: await getCompanyRelation(this.props.user.accessToken)});
    }

    getMenu() {
        return (
            <div>
                <div className="menu">
                    <ul style={{margin: 0, padding: 0, listStyleType: "none"}}>
                        <img src={require("./resources/AR-Arboreal-logo-turkos_white.png")} alt={"Arboreal"}/>
                        <Link to="/forest/measurement">
                            <div style={{float: "left", width: 230, margin: 15, cursor: "pointer"}}>
                                <li onClick={() => this.setState({alternative: "Measurements"})}>
                                <span style={{
                                    color: this.state.alternative === "Measurements" ||
                                    this.state.alternative === "front" ? "white" : "#ADADAD",
                                    float: "left"
                                }}>Measurements</span>
                                </li>
                            </div>
                        </Link>
                        {this.showCompany() ? this.getCompanyOptions() : null}
                        {this.state.admin ? this.getAdminOptions() : null}
                    </ul>
                </div>
                <div className="route">
                    <a onClick={() => {
                        if (this.state.history.length !== 0) {
                            window.location.applicationHistory.pop();
                        }
                    }}>{this.state.alternative}</a>
                    <a>{this.state.history.length !== 0 ? '/' + this.state.history[0] : null}</a>
                </div>
            </div>
        )
    }

    showCompany() {
        if (this.state.company.company_id === 0) {
            return false
        }
        return this.state.company.relation === 'admin';
    }

    getDown() {
        return (
            <div className="profile_menu" style={{backgroundColor: "white"}}>
                <div style={{
                    borderBottom: "#0f0f0f solid 1px",
                    margin: "0px 0px 0px 10px",
                    backgroundColor: "transparent",
                    color: "#212121",
                    cursor: "default"
                }}>
                    <span style={{top: "5px"}}>text text</span>
                </div>
                <div style={{margin: "0px 0px 0px 10px"}} onClick={() => console.log("text")}>
                    <span>Show Profile</span>
                </div>
                <div style={{margin: "0px 0px 0px 10px", borderBottom: "#0f0f0f solid 1px"}} onClick={() => {
                    console.log("text")
                }}>
                    <span>Create album</span>
                </div>
                <div style={{margin: "0px 0px 0px 10px"}} onClick={() => {
                    //this.props.setAlternative("help")
                    //this.setState({ showProfileMenu: false })
                }}><span>Help</span></div>
                <div style={{margin: "0px 0px 0px 10px"}} onClick={() => {
                    //this.props.setTour(true)
                    //this.setState({ showProfileMenu: false })
                }}><span>Tutorial</span></div>
                <div style={{margin: "0px 0px 0px 10px"}} onClick={() => {
                    //this.props.setAlternative("settings")
                    //this.setState({ showProfileMenu: false })
                }}><span>Settings</span></div>
                <div style={{margin: "0px 0px 0px 10px"}} onClick={() => {
                    //this.dologout()
                    //this.setState({ showProfileMenu: false })
                }}><span>Logout</span></div>
            </div>
        )
    }

    getCompanyOptions() {
        return (
            <div>
                <div style={{float: "left", width: 230, margin: 15, cursor: "pointer"}}>
                    <li onClick={() => this.setState({alternative: "company"})}>
                        <Link to="/forest/company" style={{textDecoration: "none"}}>
                            <span
                                style={{
                                    color: this.state.alternative === "company" ? "white" : "#ADADAD"
                                }}>Company</span>
                        </Link>
                        <i className="material-icons"
                           onClick={() => this.setState({showCompany: !this.state.showCompany})}
                           style={{position: "absolute", marginTop: 3, marginLeft: 2, color: "white"}}>keyboard_arrow_down
                        </i>
                        {this.state.showCompany ? this.getCompanyAlternatives() : null}
                    </li>
                </div>
            </div>
        )
    }

    getCompanyAlternatives() {
        return (
            <div className="profile_menu" style={{
                backgroundColor: "white", top: 18, left: -50, border: "1px solid black",
                height: 145
            }}>
                <div style={{
                    borderBottom: "#0f0f0f solid 1px",
                    margin: "0px 0px 0px 10px",
                    backgroundColor: "transparent",
                    color: "#212121",
                    cursor: "default"
                }}>
                    <span style={{top: "5px"}}>Company options</span>
                </div>
                <Link to="/forest/company/users">
                    <div style={{margin: "0px 0px 0px 10px"}}>
                        <span>Users</span>
                    </div>
                </Link>
                <Link to="/forest/company/api" >
                    <div style={{margin: "0px 0px 0px 10px"}}>
                        <span>Api</span>
                    </div>
                </Link>
                <Link to="/forest/company/api-docs" >
                    <div style={{margin: "0px 0px 0px 10px"}}>
                        <span>Api Docs</span>
                    </div>
                </Link>
            </div>
        )
    }

    getAdminOptions() {
        return (
            <div>
                <Link to="/forest/statistics">
                    <div style={{float: "left", margin: 15, cursor: "pointer"}}>
                        <li onClick={() => this.setState({alternative: "statistics"})}>
                            <span style={{
                                color: this.state.alternative === "statistics" ? "white" : "#ADADAD"
                            }}>Statistics</span>
                        </li>
                    </div>
                </Link>
            </div>
        )
    }

    render() {
        return (
            <div>
                {this.getMenu()}
                <div style={{backgroundColor: "white", display: "inline-block", width: "100%"}}>
                    {this.props.children}
                </div>
            </div>
        )
    }

}
